import { Field } from 'react-final-form';
import { required } from '../../helpers';
import FormError from '../Common/FormError';

const BorrowerEmployment = () => {
  return (
    <div className='mb-10 fv-row'>
      <label className='d-flex align-items-center form-label mb-3 fs-4 text-capitalize'>What is Your Employment Status</label>

      <div className='row mb-2' data-kt-buttons='true'>
        <div className='col'>
          <Field type='radio' className='btn-check' name='employment_status' value='self' id='kt_employment_type_self' validate={(v) => required(v, 'Employment')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='employment_status' className='btn-check' value='self' id='kt_employment_type_self' />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4' htmlFor='kt_employment_type_self'>
            <span className='fw-bolder fs-3'>Self Employed</span>
          </label>
        </div>

        <div className='col'>
          <Field type='radio' className='btn-check' name='employment_status' value='employed' id='kt_employment_type_self' validate={(v) => required(v, 'Employment')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='employment_status' className='btn-check' value='employed' id='kt_employment_type_employed' />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4' htmlFor='kt_employment_type_employed'>
            <span className='fw-bolder fs-3'>Employed</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default BorrowerEmployment;
